import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { BaseService } from '../shared/services/base.service';
import { TranslationService } from '../shared/i18n/translation.service';
import { News } from '../models/news.model';
 
@Injectable({
    providedIn: 'root',
})
export class PublicNewsService extends BaseService<News>  {
  
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        }),
    };
    langId: number=1;
    API_URL = `${environment.apiUrl}/PublicNews`;
    API_URLFind = `${environment.apiUrl}/PublicNews/Find`;
    API_URLGetAll = `${environment.apiUrl}/PublicNews`;
    API_URLAdd = `${environment.apiUrl}/PublicNews`;
    API_URLUpdate = `${environment.apiUrl}/PublicNews`;
    API_URLDelete = `${environment.apiUrl}/PublicNews`;
    API_URLGetById = `${environment.apiUrl}/PublicNews`;
    constructor(@Inject(HttpClient) http: HttpClient, public toastr: ToastrService, public translationServices: TranslationService) {
        super(http, toastr, translationServices);
    }

  
}
